/** The longest a side of a photo sent to the AI is, in pixels — see the nutrition spec, Asking the AI. */
export const AI_PHOTO_SIDE = 1024

/**
 * A photo read down to at most `AI_PHOTO_SIDE` on its longer side, as base64 JPEG without the
 * `data:` prefix — what the server forwards. The picked file is not kept: once this has read
 * it, nothing holds a reference.
 */
export async function downscaleToJpeg(file: Blob, side = AI_PHOTO_SIDE): Promise<string> {
  const bitmap = await createImageBitmap(file)
  try {
    const scale = Math.min(1, side / Math.max(bitmap.width, bitmap.height))
    const canvas = document.createElement('canvas')
    canvas.width = Math.max(1, Math.round(bitmap.width * scale))
    canvas.height = Math.max(1, Math.round(bitmap.height * scale))
    const context = canvas.getContext('2d')
    if (context === null) {
      throw new Error('No canvas')
    }
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
    const url = canvas.toDataURL('image/jpeg', 0.8)
    return url.slice(url.indexOf(',') + 1)
  } finally {
    bitmap.close()
  }
}
